import LogicOvertimeIndex from "./LogicOvertimeIndex.vue";
import LogicOvertimeAdd from "./LogicOvertimeAdd.vue";
import LogicOvertimeDetail from "./LogicOvertimeDetail.vue";
import LogicOvertimeEdit from "./LogicOvertimeEdit.vue";
import LogicOvertimeUpload from "./LogicOvertimeUpload.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Logic Overtime",
        },
        name: "LogicOvertimeIndex",
        component: LogicOvertimeIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Logic Overtime",
        },
        name: "LogicOvertimeAdd",
        component: LogicOvertimeAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Logic Overtime",
        },
        name: "LogicOvertimeDetail",
        component: LogicOvertimeDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Logic Overtime",
        },
        name: "LogicOvertimeEdit",
        component: LogicOvertimeEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload Logic Overtime",
        },
        name: "LogicOvertimeUpload",
        component: LogicOvertimeUpload
    },
    
]

export default routes
  